import * as React from "react";

export const repeatElement = (element: JSX.Element, times: number) =>
    [...Array(times)].map((item, index) =>
        React.cloneElement(element, { key: `repeated-item-${index.toString()}` })
    );
